/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackanchorlawyer3Inputs */

const en_artifactpackanchorlawyer3 = /** @type {(inputs: Artifactpackanchorlawyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lawyer drafting from scratch — 6–10 hours @ €100–200/hr (≈€600–€2,000)`)
};

const pt_artifactpackanchorlawyer3 = /** @type {(inputs: Artifactpackanchorlawyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advogado a redigir de raiz — 6 a 10 horas @ €100–200/h (≈€600–€2.000)`)
};

/**
* | output |
* | --- |
* | "Lawyer drafting from scratch — 6–10 hours @ €100–200/hr (≈€600–€2,000)" |
*
* @param {Artifactpackanchorlawyer3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackanchorlawyer3 = /** @type {((inputs?: Artifactpackanchorlawyer3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackanchorlawyer3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackanchorlawyer3(inputs)
	return pt_artifactpackanchorlawyer3(inputs)
});
export { artifactpackanchorlawyer3 as "artifactPackAnchorLawyer" }